import {Drawer, FormControl, FormControlLabel, Radio, RadioGroup, Stack} from "@mui/material";
import {useState} from "react";
import type {ClosedOnDays} from "../../firebase/index.js";
import {addPlace, generateStringKeyFromMillis, PlaceModel, TripModel} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";


export function useAnchorSelectorBSL(): { showAnchorSelectorBottomSheet: boolean, setShowAnchorSelectorBottomSheet: (value: boolean) => void } {
	  const [showAnchorSelectorBottomSheet, setShowAnchorSelectorBottomSheet] = useState(false);
	  return {showAnchorSelectorBottomSheet, setShowAnchorSelectorBottomSheet};
}


export function useAnchorSelectorBSLForDuplication(): { showAnchorSelectorBottomSheetForDuplication: boolean, setShowAnchorSelectorBottomSheetForDuplication: (value: boolean) => void } {
	  const [showAnchorSelectorBottomSheetForDuplication, setShowAnchorSelectorBottomSheetForDuplication] = useState(false);
	  return {showAnchorSelectorBottomSheetForDuplication, setShowAnchorSelectorBottomSheetForDuplication};
}


export default function AnchorSelectorBSL({uid, onClose, place, forDuplication = false}: BSLProps & { place: PlaceModel } & { forDuplication?: boolean }) {
	  
	  const [selectedDateMillis, setSelectedDateMillis] = useState(0);
	  
	  const inMemoryTrip: TripModel = useInMemoryTrip();
	  
	  const {isOpen, handleOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  
	  const handleCancel = () => {
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 if (/*FALSY->*/ !!!uid) {
					alert("Please login to add a new anchor");
					return;
			 }
			 if (/*FALSY->*/ !!!selectedDateMillis) {
					alert("Please select a date as anchor");
					return;
			 }
			 if (Object.keys(inMemoryTrip.tripDates).length === 0) {
					alert("Trip dates are not set yet");
					return;
			 }
			 
			 if (/*NOT->*/ !forDuplication) {
					addPlace(uid, inMemoryTrip.itineraryKey, place.anchoredOnDate, place.placeKey, null);
					place.setAnchoredOnDate(selectedDateMillis);
					addPlace(uid, inMemoryTrip.itineraryKey, place.anchoredOnDate, place.placeKey, place);
			 } else {
					const placeCopy: PlaceModel = PlaceModel.fromObject(place);
					placeCopy.setAnchoredOnDate(selectedDateMillis);
					placeCopy.placeKey = generateStringKeyFromMillis();
					if (placeCopy.isTransport) placeCopy.closedOnDays = {};
					addPlace(uid, inMemoryTrip.itineraryKey, placeCopy.anchoredOnDate, placeCopy.placeKey, placeCopy);
			 }
			 
			 handleCancel();
	  };
	  
	  return (
				 <>
						<Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
							  <Stack spacing={2} p={2}>
									 <FormControl>
											<RadioGroup value={selectedDateMillis}
															onChange={(event) => setSelectedDateMillis(Number(event.target.value))}
											>
												  {
															 Object.keys(inMemoryTrip.tripDates).length > 0
															 && Object.keys(inMemoryTrip.tripDates).map((dateMillis) => {
																	return (
																			  <FormControlLabel
																						 key={dateMillis}
																						 control={<Radio/>}
																						 label={new Date(Number(dateMillis)).toLocaleDateString("en-GB", {weekday: "short", day: "numeric", month: "short"})}
																						 value={Number(dateMillis)}
																						 disabled={doDisablingLogic(dateMillis, place)}
																			  />
																	);
															 })
												  }
											</RadioGroup>
									 </FormControl>
									 <APXActionButtons onCancel={handleCancel} onAdd={handleAdd}/>
							  </Stack>
						</Drawer>
				 </>
	  );
}


function doDisablingLogic(m: string, p: PlaceModel): boolean {
	  const obj: ClosedOnDays = {}; /* DDD string : closed boolean */
	  if (/*TRUTHY->*/!!p.closedOnDays) {
			 Object.entries(p.closedOnDays).filter(([key, value]) => value).forEach(([key, value]) => obj[key] = value);
	  }
	  if (/*TRUTHY->*/ !!p.anchoredOnDate) {
			 const DDD = new Date(Number(p.anchoredOnDate)).toLocaleDateString("en-GB", {weekday: "short"}).toUpperCase();
			 obj[DDD] = true;
	  }
	  const mDDD = new Date(Number(m)).toLocaleDateString("en-GB", {weekday: "short"}).toUpperCase().toUpperCase();
	  return Object.hasOwn(obj, mDDD);
}